import React from 'react';
import MasterForm from './components/MasterForm';
import './App.css';
import './css/css/theme.min.3868dbd9aedd1b9d4b3e.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'react-multi-carousel/lib/styles.css';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
function App() {
  return (
    <React.Fragment>
<MuiPickersUtilsProvider utils={DateFnsUtils}>
    <MasterForm />
    </MuiPickersUtilsProvider>
 </React.Fragment>
  );
}
// debugger;
export default App;
